const NS = 'MmfsDownloadPDFBtnBlock';
const CLS = 'mmfsDownloadPDFBtnBlock';

export class MmfsDownloadPDFBtnBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.moduleId = this.$element.data(`moduleId`);
		this.$downloadBtn = this.$element.find(`.${CLS}-btn`);
		this.$downloadBtn.on('click', () => {
			window.open("/mmfs-download-modules-page?moduleId="+this.moduleId);
		});
	}
}
